import Image from 'assets/backgrounds/approach.jpg';

export const title = 'Disclaimer — FondsConsult';
export const description =
  'Expertise in Fondsselektion, Benchmarking und ESG-Bewertung für fundierte Investmententscheidungen.';
export const imageUrl = `${window.location.origin}${Image}`;
export const content = 'business.business';
